import React, { useEffect, useState, useContext } from "react";

import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  GridToolbarQuickFilter,
  GRID_CHECKBOX_SELECTION_COL_DEF,
} from "@mui/x-data-grid";

import { Mask } from "../../utils/mask";
import { useLazyGetEventBuysQuery } from '../../services/eventApi';
import AppContext from "../../context/AppProvider";
import { useNotification } from '../../context/NotificationContext';
import BasicModalInformation from "../basicModalInformation";
import { parseToEasternTime } from './../../utils/dates';
import { selectAllUsers, setwhiteListAccounts } from "../../store/slices/accounts/whiteListAccounts";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import BlackList from "../../screens/adminToolsTabs/components/BlackList";
import Modal from '@mui/material/Modal';
import { selectCurrentUser } from "../../features/auth/authSlice.js";
import { useJobEditMutation } from "../../services/jobsApi.js";
import useUserTypes from "../../customHooks/useUserTypes";

import SaveAndSetAsActive from "../SaveAndSetAsActive";
import { selectAllUserTypes } from './../../store/slices/accounts/userTypes';
import DeleteJobActionButton from "../../screens/jobDetailsTabs/components/DeleteJobActionButton";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function QuickSearchToolbar({ showAllActiveUsers, setShowAllActiveUsers, userCanEditJob }) {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        margin: 0,
        padding: 0,
        height: '30px'
      }}
    >
      <div
        className="row-modal"
        style={{ justifyContent: "flex-start" }}
      >
        <h4
          style={{
            fontWeight: "600",
            color: "var(--orange)",
            margin: "0 2em 0 0",
          }}
        >
          Whitelist
        </h4>
        <GridToolbarQuickFilter
          sx={{
            // backgroundColor: 'var(--background-lightgray)',
            padding: "0 8px",
            borderRadius: "2em",
          }}
        />
      </div>
      <FormControlLabel control={
        <Checkbox disabled={!userCanEditJob} checked={showAllActiveUsers} onClick={() => setShowAllActiveUsers((prevState) => !prevState)} />
      } label="Show all active users" style={{ whiteSpace: "nowrap" }} />
    </Box>
  );
}

const WhiteList = ({ jobInfo, setJobInfo, userCanEditJob, eventInfo, escalation, setEscalation, resolveOptions, getJobInfo }) => {

  const { showNotification } = useNotification();

  const [initJobEdit, { isLoading: jobEditIsLoading }] = useJobEditMutation();
  const [users, setUsers] = useState(null);
  const [fetchingWhiteList, setFetchingWhiteList] = useState(false);
  const [fetchingSaveAndSetAsActive, setFetchingSaveAndSetAsActive] = useState(false);
  const [fetchResponse, setFetchResponse] = useState(null);
  const [showAllActiveUsers, setShowAllActiveUsers] = useState(false)
  const reduxUsers = useSelector(selectAllUsers)
  const userTypes = useUserTypes();
  const [ROWSCOUNTER, setROWSCOUNTER] = useState(null)
  const [showUserBlackListInfo, setShowUserBlackListInfo] = useState(false);//A: this variable can be the user object or false, and its the flag to open or close the modal

  const [initGetEventBuys, { isLoading: getEventBuysIsLoading }] = useLazyGetEventBuysQuery();

  const dispatch = useDispatch()

  useEffect(() => {
    try {
      console.log("reduxUsers", reduxUsers);
      if (reduxUsers.length <= 0) return;
      showAllActiveUsers ? setUsers(reduxUsers) : setUsers(reduxUsers.filter((user) => user.userDistribution))
    } catch (error) {
      console.log("ACCOUNTS, error in useEffect: ", error)
    }
  }, [reduxUsers, showAllActiveUsers])



  useEffect(() => {
    async function initGetBuys() {
      try {
        if (!jobInfo || Object.keys(jobInfo).length === 0 || jobInfo?.id === 0) return;

        const { data, error } = await initGetEventBuys(`${jobInfo?.id}`);

        if (error) {
          console.error("Error fetching event buys:", error);
          return;
        }

        if (data) {
          console.log("USERS BUYS fetch: ", data);
          const sortedData = [...data].sort((x, y) =>
            (x.userDistribution === y.userDistribution) ? 0 : x.userDistribution ? -1 : 1
          );

          dispatch(setwhiteListAccounts(sortedData));
        }
      } catch (error) {
        console.error("Error getting event buys from server:", error);
      }
    }
    initGetBuys();
  }, [jobInfo, initGetEventBuys, dispatch]);


  const user = useSelector(selectCurrentUser);


  const [selectedUsers, setSelectedUsers] = useState([]);

  async function handleMaskSubmit(buttonTypeName) {

    if (buttonTypeName === "SaveChanges") {
      setFetchingWhiteList(true);
    }

    if (buttonTypeName === "SaveAndSetAsActive") {
      setFetchingSaveAndSetAsActive(true);
    }

    let newMask = new Mask(selectedUsers).asString();

    let jobEdited = {
      id: jobInfo.id,
      userMask: newMask,
      currentOwnerHiveUserId: null,
      useEvenDistribution: jobInfo.useEvenDistribution
    };

    console.log("job put request: " + JSON.stringify(jobEdited));

    try {
      const response = await initJobEdit({ job: jobEdited, userId: user.id }).unwrap();
      console.log("job put res: ", response);
      
      // if the request is an error we show a success message
      if (response.error) {
        showNotification(response.error.message || "An error occurred while saving changes", 'error');
      } else {
        // if the request is OK we show a success message
        showNotification('Changes saved successfully', 'success');        
        // Updating the jobInfo
        setJobInfo(prevState => ({
          ...prevState,
          job: {
            ...prevState.job,
            userMask: newMask
          }
        }));
      }
    } catch (error) {
      console.error("error on submit mask: ", error);
      showNotification(error.message || "An error occurred while saving changes", 'error');
    } finally {

      if (buttonTypeName === "SaveChanges") {
        setFetchingWhiteList(false);
      }
  
      if (buttonTypeName === "SaveAndSetAsActive") {
        setFetchingSaveAndSetAsActive(false);
      }

    }
  }

  useEffect(() => {
    if (jobInfo?.userMask) {
      let maskArray = new Mask(jobInfo?.userMask);
      setSelectedUsers(maskArray.asIntArray());
    }
  }, [jobInfo]);

  let limit = eventInfo
    ? eventInfo.useRunLevelLimit
      ? eventInfo.runLimitNumberOfTickets
      : eventInfo.eventLimitNumberOfTickets
    : null;

  function getRemainingTickets(params) {
    let ticketsCanBuy;
    if (eventInfo?.useRunLevelLimit)
      ticketsCanBuy =
        eventInfo?.runLimitNumberOfTickets - params.row.sum_QtyPurchasedPerRun;
    else
      ticketsCanBuy =
        eventInfo?.eventLimitNumberOfTickets -
        params.row.sum_QtyPurchasedPerEvent;
    return ticketsCanBuy >= 0 ? ticketsCanBuy : 0; //FIX: dont return negative values
  }

  const styleCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  if (getEventBuysIsLoading) {
    return (
      <div style={styleCenter}>
        <CircularProgress size={48} sx={{ color: "primary" }} />
      </div>
    );
  }

  return (
    <div>
      <BasicModalInformation
        open={fetchResponse && fetchResponse.status === "error"}
        title={fetchResponse?.message}
      />
      <div style={{ height: "60vh", width: "100%" }}>
        {users ? (
          <DataGridPro
            rowHeight={38}
            headerHeight={40}
            onSelectionModelChange={(e) => setSelectedUsers(e)}
            sx={{
              borderRadius: "1em",
              backgroundColor: "white",
              padding: "1em",
              '&:disabled': {
                backgroundColor: "red",
              }
            }}
            columns={[
              { field: "id", hide: true },
              {
                ...GRID_CHECKBOX_SELECTION_COL_DEF,
                width: 50,
              },
              {
                headerName: "USER NAME", field: "firstName", flex: 1, renderCell: ({ row }) => {
                  let { isBlacklisted, firstName } = row;
                  // let BlackListTag= params.row.isBlacklisted ? <Chip label="Blacklisted" color="error" size="small" onClick={()=> alert("click en blacklist")}/> : ''

                  // return `${params.row.firstName} ${<BlackListTag/>}` }
                  return (
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>{`${firstName}`} </Grid>
                      <Grid item>{isBlacklisted && <Chip label="Blacklisted" color="error" size="small" onClick={() => setShowUserBlackListInfo(row)} />}</Grid>
                    </Grid>
                  )
                }
              },
              { headerName: "USER LASTNAME", field: "lastName", flex: 1 },
              { headerName: "STATE", field: "state", flex: 1 },
              {
                headerName: "REMAINING TICKETS",
                valueGetter: getRemainingTickets,
                field: eventInfo?.useRunLevelLimit
                  ? "sum_QtyPurchasedPerRun"
                  : "sum_QtyPurchasedPerEvent",
                flex: 1, align: 'center',
              },
              {
                headerName: "LAST CLAIMED DATE", field: "lastClaimDate", flex: 1, align: 'center',
                renderCell: (params) => {

                  if (params.row.lastClaimDate) return parseToEasternTime(params.row.lastClaimDate + "Z")
                  return "-"
                }
              },
              {
                headerName: "USER TYPE", field: "userTypeId", flex: 1,
                // use userTypes lookUp table to get the name of the user type
                renderCell: (params) => {
                  let userType = userTypes.find((ut) => ut.id == params.row.userTypeId);
                  return userType?.name;
                }
              },
            ]}

            rows={users}

            isRowSelectable={(params) => {
              if (!userCanEditJob) return false;
              if (!params.row.userDistribution) return false;
              return eventInfo.useRunLevelLimit
                ? params.row.sum_QtyPurchasedPerRun + jobInfo?.quantity <= limit
                : params.row.sum_QtyPurchasedPerEvent + jobInfo?.quantity <=
                limit;
            }} // user buyed + job quiantity  should be less than limit or per run based on useRun true or false
            checkboxSelection={true}
            getRowClassName={(params) => {
              if (!userCanEditJob) return `mui-custom-row`
              if (!params.row.userDistribution) return `mui-custom-row-red`
              if (eventInfo.useRunLevelLimit && params.row.sum_QtyPurchasedPerRun + jobInfo?.quantity > limit) {
                return `mui-custom-row`
              } else if (params.row.sum_QtyPurchasedPerEvent + jobInfo?.quantity > limit) {
                return `mui-custom-row`
              } else {
                return `.mui-custom-row-white`
              }
            }}
            disableSelectionOnClick
            selectionModel={selectedUsers}
            components={{ Toolbar: QuickSearchToolbar }}
            componentsProps={{
              toolbar: { showAllActiveUsers, setShowAllActiveUsers, userCanEditJob, ROWSCOUNTER },
            }}
          />
        ) : null}
      </div>

      <div className="modal-buttons" style={{ margin: "1em 0 0 0" }}>
        {/* <Button variant='contained' color='secondary' >Cancel Changes</Button> */}

        <DeleteJobActionButton disabled={!userCanEditJob} jobId= {jobInfo?.id} />

        <Button
          variant="contained"
          sx={
            userCanEditJob
              ? { margin: "0 0 0 1em", }
              : {
                margin: "0 0 0 1em",
                backgroundColor: "var(--grey-inactive)",
                color: "white",
                borderRadius: "2em",
              }
          }
          onClick={() => handleMaskSubmit("SaveChanges")}
          disabled={!userCanEditJob}
        >{
            fetchingWhiteList ? (
              <CircularProgress sx={{ color: 'white' }} size={24} />
            ) : (
              "Save Changes"
            )}
        </Button>

        <SaveAndSetAsActive 
          userCanEditJob={userCanEditJob} 
          escalation={escalation} user={user} 
          resolveOptions={resolveOptions} 
          issueResolvedNote="" 
          saveChanges={handleMaskSubmit} 
          fetching={fetchingSaveAndSetAsActive} 
          setFetching={setFetchingSaveAndSetAsActive} 
          getJobInfo={getJobInfo} 
        />

        <Modal
          open={showUserBlackListInfo}
          onClose={() => setShowUserBlackListInfo(false)}
        >


          <Box
            sx={{
              ...style,
              padding: "2em",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" },
              backgroundColor: "var(--background-lightgray)",
              borderRadius: "2em",
            }}
          >
            <Box sx={{ width: 1 }} style={{ 'min-height': '613px' }}>
              <h4 style={{ margin: '0 0 0.5em 0', fontWeight: '700', color: 'var(--orange)' }} > {showUserBlackListInfo.firstName + " " + showUserBlackListInfo.lastName + "'s"} Venue Blacklist </h4>
              <Divider style={{ margin: '0 0 1em 0' }} />
              <BlackList user={showUserBlackListInfo}></BlackList>
            </Box>
          </Box>

        </Modal>




      </div>
    </div>
  );
};

export default WhiteList;
